import FetchError from '../FetchError'

export const cancellationErrorMessage = (
  error: unknown,
  undo: boolean
): string => {
  if (error instanceof FetchError) {
    if (error.status === 403)
      return 'Du har ikke tilgang til å endre kanselleringen.'
    if (error.status === 409) {
      return undo
        ? 'Kanselleringen kan ikke angres automatisk. Kontakt administrator for å avklare prøvens status.'
        : 'Prøven kan ikke kanselleres i sin nåværende status. Oppdater siden og kontroller prøvens status.'
    }
    if (error.status === 412)
      return 'Prøven er endret. Oppdater siden og prøv igjen.'
  }
  return undo
    ? 'Kunne ikke angre kanselleringen. Prøv igjen.'
    : 'Kunne ikke kansellere delprøven. Prøv igjen.'
}
